import { useCallback } from 'react';
import { useMediaQuery } from 'react-responsive';
import { BREAKPOINTS } from '@/constants/breakpoints';
import useUserPreference from './useUserPreference';

const PREFERENCE_KEY = 'sidebarPinned';

/**
 * Whether the sidebar keeps its full width and pushes the content aside, or
 * shrinks to an icon rail.
 *
 * Until the user expresses a preference the answer depends on how much room the
 * screen has: below 1440 the 288px column costs the boards more than the
 * always-visible labels are worth. Once they choose, their choice wins on every
 * screen and every device, because a menu that silently reopens on a different
 * machine feels like the site forgot them.
 */
const useSidebarPinned = (): [boolean, () => void] => {
  const hasRoomForBoth = useMediaQuery({ minWidth: BREAKPOINTS.DESKTOP });
  const [stored, setStored] = useUserPreference(PREFERENCE_KEY);

  const isPinned = stored === 'true' ? true : stored === 'false' ? false : hasRoomForBoth;

  const togglePinned = useCallback(() => {
    setStored(String(!isPinned));
  }, [isPinned, setStored]);

  return [isPinned, togglePinned];
};

export default useSidebarPinned;
